import OurProjectVerticalForm from "../../our-project-vertical/Form";
import { useCommercialDesignProjects } from "../../useHook";

const OurProjectCommercialEdit = () => {
  return (
    <OurProjectVerticalForm
      isEditMode={true}
      useProjectsHook={useCommercialDesignProjects}
      listPath="/our-project-commercial-design"
      subtitle="Commercial construction project"
    />
  );
};

export default OurProjectCommercialEdit;
